/**
* 系统的登录页面
*/
<template>
	<div class="login-container">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<div class="login-box">
			<h2>Login</h2>
			<form @submit.prevent="login">
				<div class="form-group">
					<label for="username">{{ $t('language000087') }}</label>
					<input type="text" id="username" v-model="username" placeholder="QIUI APP User ID" required />
				</div>
				<div class="form-group">
					<label for="password">{{ $t('language000088') }}</label>
					<input type="text" id="password" v-model="password" placeholder="QIUI APP login account" required />
				</div>
				<button type="submit" click="login()">Login</button>
			</form>
		</div>


	</div>
</template>

<script>
	//执行顺序是beforeCreate -> created -> beforeMount -> mounted

	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		created() { // 在组件创建时触发，通常用于初始化数据
		},
		mounted() {
			const userLanguage = navigator.language || navigator.userLanguage; // 获取用户浏览器所配置的语言偏好
			//alert(userLanguage);
			const isLanguageSupported = this.$p_languages.includes(userLanguage); // 检查用户语言是否在支持的语言列表中
			// 如果语言受支持，则设置为用户语言，否则设置为默认语言
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;
		},
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				username: '',
				password: '',
			};
		},
		methods: {
			login() {
				this.loadingData = true;
				const requestData = {};
				if (this.isUsernameNumeric()) { //0（手机号 + id），1（邮箱 + id）
					requestData.checkType = 0;
					requestData.phoneNumber = this.password;
				} else {
					requestData.checkType = 1;
					requestData.email = this.password;
				}
				requestData.userId = this.username;

				console.log("登录传递给后台的数据：", requestData)
				axios.post(this.$p_url + '/feign/stripe/getCheckH5LoginUserRes', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("登录的返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "success") { // 检查状态
							Cookies.set("token", response.data.data.token, {
								expires: 1
							});
							console.log("缓存的token：", Cookies.get("token"))
							this.$router.push({ //跳转到首页
								path: '/StripeHome',
								query: {
									data: JSON.stringify(response.data.data), // 将对象转换为字符串
								}
							});
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						console.error('Error fetching data:', error);
					});
			},
			isUsernameNumeric() {
				// 使用正则表达式判断是否为纯数字
				const isNumeric = /^\d+$/.test(this.password);
				return isNumeric;
			},
		},
	};
</script>

<style scoped>
	.login-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background-color: #f2f2f2;
	}

	.login-box {
		background-color: #fff;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	}

	h2 {
		text-align: center;
		color: #333;
	}

	form {
		display: flex;
		flex-direction: column;
	}

	.form-group {
		margin-bottom: 15px;
	}

	label {
		font-weight: bold;
		margin-bottom: 5px;
		color: #555;
	}

	/* 在<style scoped>中添加以下样式 */
	input {
		padding: 10px;
		border: 1px solid #ccc;
		border-radius: 4px;
		width: calc(100% - 20px);
		/* 通过减去 padding 的大小来避免重叠 */
		margin-bottom: 10px;
		/* 添加底部间距，避免与下一个元素重叠 */
	}


	button {
		padding: 10px;
		background-color: #4caf50;
		color: #fff;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		transition: background-color 0.3s;
	}

	button:hover {
		background-color: #45a049;
	}
</style>